export default __webpack_public_path__ + "static/media/BrutalType-Regular.28b79b18.woff2";